module.exports = __webpack_public_path__ + "account/img/133.65403084.png";